import React, { useState, useEffect, useRef } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Paging
} from 'devextreme-react/data-grid';
import moment from 'moment-timezone';
import {
    Chart, Series as ChartSeries, CommonSeriesSettings, Export, Tooltip, Legend as ChartLegend, Size, ArgumentAxis, ValueAxis, Tick, Label, Title, Font
  } from 'devextreme-react/chart';
import DOMPurify from 'dompurify';
import TenantService from 'api/tenant.service';
import OverviewService from 'api/overview.service'
import Toast from 'components/Toast';
import './style.css';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import { DateBox } from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import jsPDF from 'jspdf';
// import domtoimage from 'dom-to-image';
import domtoimage from 'dom-to-image-more';
import {Tooltip as DevextremeToolTip} from 'devextreme-react';
import html2canvas from 'html2canvas';
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone


export default function Events() {
  const downloadTargetRefEvents = useRef();
  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState([])
  const [events, setEvents] = useState([]);
  const [eventFilters, setEventFilters] = useState([]);
  const [loadingText, setLoadingText] = useState('Loading events...');
  const [eventWarning, setEventWarning] = useState(0);
  const [eventAlarm, setEventAlarm] = useState(0);
  const [eventCritical, setEventCritical] = useState(0);
  const [eventInformation, setEventInformation] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  
  const [selectedValue, setSelectedValue] = useState('Last 24 hours');
  const tenant = TenantService.getTenant()
  const dropDataGridRef = useRef();
  const dateBoxRefStartEvent = useRef(null);
  const dateBoxRefEndEvent = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });


const downloadReport = async () => {
  setLoading(true);
  const elementToCapture = document.getElementById('full-page-content-events');
  const grid = dropDataGridRef.current?.instance();

  if (!elementToCapture || !grid) {
    console.error('Missing DOM or grid reference');
    setLoading(false);
    return;
  }

  // Ensure full grid rendering before capture
  grid?.updateDimensions();

  // Wait a bit to allow repaint
  await new Promise(r => setTimeout(r, 500));

  try {
    const canvas = await html2canvas(elementToCapture, {
      scale: 2,
      useCORS: true,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      logging: false,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const margin = 10;
    const pdfWidth = pageWidth - margin * 2;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', margin, margin, pdfWidth, pdfHeight);

    // Now export DataGrid data via autoTable
    const columns = grid.getVisibleColumns().filter(c => c.dataField);
    const headerTitles = columns.map(c => c.caption);
    const rows = grid.getVisibleRows().map(row =>
      columns.map(col => {
        const keys = col.dataField.split('.');
        let val = row.data;
        keys.forEach(k => { val = val?.[k]; });
        if (col.dataField === 'lastKnownLocation.timestamp' && val) {
          val = new Date(val).toLocaleString('en-US', {
            weekday: 'short', year: 'numeric', month: 'short', day: '2-digit',
            hour: 'numeric', minute: 'numeric', hour12: true,
          });
        }
        return val ?? '';
      }),
    );

    pdf.autoTable({
      startY: pdfHeight + margin + 10,
      head: [headerTitles],
      body: rows,
      headStyles: { fillColor: [181, 22, 22], textColor: [255, 255, 255] },
      styles: { fontSize: 8, overflow: 'linebreak' },
      margin: { top: 10 },
    });

    pdf.save(`Events-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`);
  } catch (err) {
    console.error('PDF generation failed:', err);
  } finally {
    setLoading(false);
  }
};

  
  

// const downloadReport = () => {
//   setLoading(true);
//   const elementToCapture = document.getElementById('full-page-content-events');

//   const grid = dropDataGridRef.current.instance;
//   const columns = grid.getVisibleColumns().filter(col => col.dataField).map(col => ({ header: col.caption, dataField: col.dataField }));
//   const rows = grid.getVisibleRows().map(row => {
//     return columns.map(col => {
//       const nestedKeys = col.dataField.split('.');
//       let value = row.data;
//       nestedKeys.forEach(key => {
//         if (value && typeof value === 'object') {
//           value = value[key];
//         } else {
//           value = undefined;
//         }
//       });
//       if (col.dataField === 'lastKnownLocation.timestamp' && value !== '' && value !== undefined && value !== null) {
//         value = new Date(value).toLocaleString('en-US', {
//           weekday: 'short',
//           year: 'numeric',
//           month: 'short',
//           day: '2-digit',
//           hour: 'numeric',
//           minute: 'numeric',
//           hour12: true
//         });
//       }
//       return value;
//     });
//   });

//   domtoimage.toPng(elementToCapture, { quality: 0.1,
//     skipAutoImageLoad: true,
//     filter: (node) => !(node.tagName === 'IMG'),
//     cacheBust: true })
//     .then((dataUrl) => {
//       const pdf = new jsPDF();

//       // Add the captured image as the first page in the PDF
//       pdf.addImage(dataUrl, 'PNG', 10, 10, 190, 120); // Adjust the position and size as needed

//       // Add the grid data as subsequent pages using autoTable
//       pdf.autoTable({
//         head: [columns.map(col => col.header)],
//         body: rows,
//         headStyles: {
//           fillColor: [181, 22, 22], // Red color
//           textColor: [255, 255, 255] // White text color
//         },
//         startY: 130 // Adjust the start position if needed
//       });

//       // Save the combined PDF with a specified filename
//       pdf.save(`Events-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`);
//       setLoading(false);
//     })
//     .catch((error) => {
//       setLoading(false);
//       console.error('Error capturing element or generating PDF:', error);
//     });
//   };

  const customizeEventsLabel = (arg) => {
    return {
      text: `${arg.valueText}`,
    };
  }

  async function getData(applyD, yes) {
    setLoading(true)
    setData([])
    // let fromDate = await moment(state2[0].startDate).utc().format();
    // let toDate = await moment(state2[0].endDate).utc().format();
    const fromDate = moment(localStorage.getItem(`${tenant}dateFilterFrom`)).utc().format();
    const toDate = moment(localStorage.getItem(`${tenant}dateFilterTo`)).utc().format();
    if (fromDate === "Invalid date" || toDate === "Invalid date"){ 
      setLoading(false); // Stop loader after response (success or error)
      return true;
    }

    const toDateCheck = new Date(localStorage.getItem(`${tenant}dateFilterTo`))
    const fromDateCheck = new Date(localStorage.getItem(`${tenant}dateFilterFrom`))
    if (toDateCheck.getTime() < fromDateCheck.getTime()) {
      setLoading(false); 
      return true;
    }
    if (yes === true) {
      await OverviewService.getEvents(fromDate, toDate, timeZone).then((value) => {
        if(value.data === null) return;
        if (value?.data?.data?.eventData.length === 0) setLoadingText("No Data")
        else setLoadingText("Loading events...")
        setData(value?.data?.data?.eventData);
        const periodVal = localStorage.getItem(`${tenant}dateFilterText`);
        customizeBarData(value.data.data.eventData, fromDate, toDate, periodVal)
      }).finally(() => {
        setLoading(false); // Stop loader after response (success or error)
      });
    } else {
      setData([])
      setEvents([])
      setLoading(false)
    }
  }

  // const customizeBarData = async (eventListing, fromDate, toDate) => {
  //   let start_time = moment(fromDate).startOf('day');
  //   let end_time = moment(toDate).endOf('day');
  //   let arr = [];
  //   let calendar = false;
  //   if (selectedValue === 'Last 24 hours') {
  //     start_time = moment().subtract(24, 'hours');
  //     end_time = moment();
  //   }
  //   // when its a same day
  //   // let isSameDay = false;

  //   // when nothing is selected

  //   const maxBars = 25

  //   let hours = end_time.diff(start_time, 'days');
  //   hours = hours===0?1:(hours==1 && calendar==true ? 2 : hours);
  //   for(let i=0;i<=maxBars;i++){
  //     arr.push(moment(start_time).add(i*hours, 'hours').startOf('hour').format("YYYY-MM-DD HH:mm:ss"));
  //   }

  //   const listkeys = eventListing
  //   let data=[];
  //   let alarmCount = 0, warningCount = 0,informationCount = 0, criticalCount = 0

  //   for(let i=0;i<arr.length;i++){

  //       let all_find_time = listkeys.filter(element => (moment(element.time) >= moment(arr[i])) && (moment(element.time) <= moment(arr[i]).add((hours * 60) - 1, 'minutes') ))

  //       if(all_find_time.length > 0) {
  //           let criticals = all_find_time.filter(element => element.severity === 'Critical').length;
  //           let alarms = all_find_time.filter(element => element.severity === 'Alarm').length;
  //           let warnings = all_find_time.filter(element => element.severity === 'Warning').length;
  //           let informations = all_find_time.filter(element => element.severity === 'Information').length;

  //           alarmCount += parseInt(alarms) || 0
  //           criticalCount += parseInt(criticals) || 0
  //           warningCount += parseInt(warnings) || 0
  //           informationCount += informations || 0

  //           data.push({
  //               time: moment(arr[i]).format('yyyy-MM-DD HH:mm'),
  //               critical: criticals,
  //               alarm: alarms,
  //               warning: warnings,
  //               information: informations,
  //           });
  //       } else {
  //           data.push({
  //             time: moment(arr[i]).format('yyyy-MM-DD HH:mm'), //'02:00<br/> 23 jun 2023'
  //             critical: 0,
  //             alarm: 0,
  //             warning: 0,
  //             information: 0,
  //           })
  //       }
  //   }
  //   setEvents(data);
  //   setEventAlarm(alarmCount)
  //   setEventCrictical(criticalCount)
  //   setEventInformation(informationCount)
  //   setEventWarning(warningCount)
  // }

  // const customizeBarData = async (eventListing, fromDate, toDate, ) => {
  //   let startTime = moment(fromDate).startOf('day');
  //   let endTime = moment(toDate).endOf('day');
  //   const ticks = [];
  //   const maxBars = 25;
  //   const isLast24Hours = selectedValue === 'Last 24 hours';
  
  //   if (isLast24Hours) {
  //     startTime = moment().subtract(24, 'hours');
  //     endTime = moment();
  //   }
  
  //   // Calculate the interval (in hours or days)
  //   const interval = endTime.diff(startTime, 'days') || 1;
  //   const step = interval / maxBars;
  
  //   // Add first tick (startTime)
  //   ticks.push(startTime.format("YYYY-MM-DD HH:mm:ss"));
  
  //   // Generate intermediate ticks
  //   for (let i = 1; i < maxBars; i++) {
  //     ticks.push(
  //       moment(startTime)
  //         .add(i * step, 'days')
  //         .startOf('hour')
  //         .format("YYYY-MM-DD HH:mm:ss")
  //     );
  //   }
  
  //   // Add last tick (endTime)
  //   ticks.push(endTime.format("YYYY-MM-DD HH:mm:ss"));
  
  //   // Prepare event data
  //   const eventData = [];
  //   let totalCritical = 0,
  //     totalAlarms = 0,
  //     totalWarnings = 0,
  //     totalInfo = 0;
  
  //   for (let i = 0; i < ticks.length; i++) {
  //     const startTick = moment(ticks[i]);
  //     const endTick = moment(ticks[i + 1] || ticks[i]).add(step * 60 - 1, 'minutes');
  
  //     // Filter events for the current time range
  //     const eventsInRange = eventListing.filter(
  //       (event) => moment(event.time).isBetween(startTick, endTick, null, "[)")
  //     );
  
  //     // Aggregate severities
  //     const severityCounts = eventsInRange.reduce(
  //       (acc, event) => {
  //         acc[event.severity.toLowerCase()]++;
  //         return acc;
  //       },
  //       { critical: 0, alarm: 0, warning: 0, information: 0 }
  //     );
  
  //     totalCritical += severityCounts.critical;
  //     totalAlarms += severityCounts.alarm;
  //     totalWarnings += severityCounts.warning;
  //     totalInfo += severityCounts.information;
  
  //     // Push data for this tick
  //     eventData.push({
  //       time: startTick.format("yyyy-MM-DD HH:mm"),
  //       ...severityCounts,
  //     });
  //   }
  
  //   // Update state
  //   setEvents(eventData);
  //   setEventAlarm(totalAlarms);
  //   setEventCritical(totalCritical);
  //   setEventInformation(totalInfo);
  //   setEventWarning(totalWarnings);
  // };

  const customizeBarData = async (eventListing, startDate, endDate) => {
    let startTime = moment(startDate);
    let endTime = moment(endDate);
    const ticks = [];
    const maxBars = 25;
    const durationMs = endTime.diff(startTime);
  
    if (durationMs <= 0) {
      console.warn("Invalid time range: start is after end");
      return;
    }
  
    const stepMs = Math.floor(durationMs / maxBars);
  
    for (let i = 0; i <= maxBars; i++) {
      ticks.push(moment(startTime).add(i * stepMs).format("YYYY-MM-DD HH:mm:ss"));
    }
  
    const eventData = [];
    let totalCritical = 0,
      totalAlarms = 0,
      totalWarnings = 0,
      totalInfo = 0;
  
    for (let i = 0; i < ticks.length - 1; i++) {
      const startTick = moment(ticks[i]);
      const endTick = moment(ticks[i + 1]);
  
      const eventsInRange = eventListing.filter((event) =>
        moment(event.time).isBetween(startTick, endTick, null, "[)")
      );
  
      const severityCounts = eventsInRange.reduce(
        (acc, event) => {
          acc[event.severity?.toLowerCase()]++;
          return acc;
        },
        { critical: 0, alarm: 0, warning: 0, information: 0 }
      );
  
      totalCritical += severityCounts.critical;
      totalAlarms += severityCounts.alarm;
      totalWarnings += severityCounts.warning;
      totalInfo += severityCounts.information;
  
      eventData.push({
        time: startTick.format("YYYY-MM-DD HH:mm"),
        ...severityCounts,
      });
    }
  
    // Set chart data
    setEvents(eventData);
    setEventAlarm(totalAlarms);
    setEventCritical(totalCritical);
    setEventInformation(totalInfo);
    setEventWarning(totalWarnings);
  };
  
  

  function computeValType(rowData) {
    return rowData.subtype;
  }

  function handleEntityName(rowData){
    return `${rowData.entityname} ${rowData.name}`
  }


  useEffect(() => {
    if (startDate && endDate) {
      getData(null, true);
    }
}, [startDate, endDate]);
  

  useEffect(() => {
    const periodVal = localStorage.getItem(`${tenant}dateFilterText`);
    if (periodVal !== null && periodVal !== 'null') {
      console.log('period val: ', periodVal);
      if (periodVal === 'Custom') {
          const startDate = moment(localStorage.getItem(`${tenant}dateFilterFrom`));
          const endDate = moment(localStorage.getItem(`${tenant}dateFilterTo`));
          setStartDate(startDate);
          setEndDate(endDate);
      }
      // setSelectedValue(periodVal);
      handleValueChange(periodVal);
    } else {
      // setSelectedValue('Today');
      handleValueChange('Last 24 hours')
    }
    getData(null, true);
}, []);


  const handleStartDate = () => {
    dateBoxRefStartEvent.current.instance().open()
    setSelectedValue("Custom")
  }
  
  const handleEndDate = () => {
    dateBoxRefEndEvent.current.instance().open()
    setSelectedValue("Custom")
  }

  const handleStartDateChange = async (value) => {
    await setStartDate(value);
    if (value && endDate && moment(value).isAfter(endDate)) {
      await setEndDate(moment(value).add(1, 'days').toDate());
      localStorage.setItem(`${tenant}dateFilterTo`, moment(value).add(1, 'days').toDate())
    }
    localStorage.setItem(`${tenant}dateFilterFrom`, moment(value).format())
    // getAnchors()

    if (endDate) {
      localStorage.setItem(`${tenant}dateFilterTo`, moment(endDate).format());
    }
    getData(null, true);
  };

  const handleEndDateChange = async (value) => {
    await setEndDate(value);
    if (value && startDate && moment(value).isBefore(startDate)) {
      await setStartDate(moment(value).subtract(1, 'days').toDate());
      localStorage.setItem(`${tenant}dateFilterFrom`, moment(value).subtract(1, 'days').toDate())
    }
    localStorage.setItem(`${tenant}dateFilterTo`, moment(value).format())
    // getAnchors()
    if (startDate) {
      localStorage.setItem(`${tenant}dateFilterFrom`, moment(startDate).format());
    }
    getData(null, true);
  };

  async function onLegendClick (e) {
    if(e.target._visible) {
      setEventFilters([...eventFilters, e.target.name])
    } else {
      let list = eventFilters
      list.splice(list.indexOf(e.target.name), 1)
      setEventFilters(list);
      if(eventFilters.length==0){
        setFilterData(data)
      } else{
        const results = data.filter(item=> !list.includes(item.severity))
        setFilterData(results)
      }
    }
    e.target._visible ? e.target.hide() : e.target.show()
  }

  const handleValueChange = async (value) => {
    setSelectedValue(value);
    if (value === 'Custom') {
      setIsDisabled(false)
      localStorage.setItem(`${tenant}dateFilterText`, value);
    } else {
      // setManageDateBox(true);
      setStartDate(null);
      setEndDate(null);
      let start, end;
      switch (value) {
        case 'Last 24 hours':
          start = moment().subtract(24, 'hours').format();
          end = moment().format();
          break;
        case 'Today':
          start = moment().startOf('day').format();
          end = moment().endOf('day').format();
          break;
        case 'Last 5 min':
          start = moment().subtract(5, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 20 min':
          start = moment().subtract(20, 'minutes').format();
          end = moment().format();
          break;
        case 'Last 1 hour':
          start = moment().subtract(1, 'hour').format();
          end = moment().format();
          break;
        case 'Last 4 hours':
          start = moment().subtract(4, 'hours').format();
          end = moment().format();
          break;
        case 'Last 12 hours':
          start = moment().subtract(12, 'hours').format();
          end = moment().format();
          // if (moment(end).diff(start, 'hours') <= 12) {
          //   end = moment().endOf('hour').format(); // Set end to end of current hour
          // }
          break;
        case 'Yesterday':
          start = moment().subtract(1, 'day').startOf('day').format();
          end = moment().subtract(1, 'day').endOf('day').format();
          break;
        case 'This Week':
          start = moment().startOf('week').format();
          end = moment().endOf('week').format();
          break;
        case 'Last Week':
          start = moment().subtract(1, 'weeks').startOf('week').format();
          end = moment().subtract(1, 'weeks').endOf('week').format();
          break;
        case 'This Month':
          start = moment().startOf('month').format();
          end = moment().endOf('month').format();
          break;
        case 'Last Month':
          start = moment().subtract(1, 'month').startOf('month').format();
          end = moment().subtract(1, 'month').endOf('month').format();
          break;
        // case 'Last 1 day':
        //   start = moment().subtract(1, 'day').format();
        //   end = moment().format();
        //   break;
        case 'Last 7 days':
          start = moment().subtract(7, 'days').format();
          end = moment().format();
          break;
        default:
          break;
      }
      console.log('start: ', start, ',end: ', end);
      await setStartDate(start);
      await setEndDate(end);
      // localStorage.setItem(tenant + "dateFilterText", `${value}`)
      localStorage.setItem(tenant + "dateFilterFrom", `${start}`)
      localStorage.setItem(tenant + "dateFilterTo", `${end}`)
      localStorage.setItem(`${tenant}dateFilterText`, value);
    }
  };

  useEffect(() => {
    const results = data.filter(item=> !eventFilters.includes(item.severity))
    setFilterData(results)
  }, [eventFilters, data]);

  return (
  <>
  <div className="page-content" style={{overflowY: "scroll"}} >
    <div id="full-page-content-events" className='eventscontainer' ref={downloadTargetRefEvents}>
		<div className='pageFullWidthEvents'>
			<h5 className='marginZeroEvents' style={{marginBottom: "15px"}}><b>Events</b></h5>
      <section className='Events_text_wrapper'>
      <p className='eventsDesc'>In the selected date range there were <b>{eventWarning} warning(s)</b>, <b>{eventAlarm} alarm(s)</b>, <b>{eventCritical} critical events(s)</b> and <b>{eventInformation} information event(s)</b>.</p>
      <div className='uploadBtnAssetsReport download_btn' style={{right: "295px", top: "20px"}}>
        <button id="generatePdfButton" alt="Download Report" type="button" onClick={() => downloadReport('events')}>
          {/* <img src="/icons/reports.svg" alt="Download Report" /> */}
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
             width="24px" height="24px" viewBox="0 0 111.000000 127.000000"
             preserveAspectRatio="xMidYMid meet">
            
            <g transform="translate(0.000000,127.000000) scale(0.100000,-0.100000)"
            fill="var(--app-text)" stroke="none">
            <path d="M40 1230 c-20 -20 -20 -33 -20 -594 0 -316 3 -581 6 -590 5 -14 48
            -16 377 -16 l372 0 132 132 133 133 0 457 c0 445 -1 459 -20 478 -19 19 -33
            20 -490 20 -457 0 -471 -1 -490 -20z m930 -449 l0 -399 -124 -3 c-168 -5 -165
            -2 -168 -168 l-3 -126 -292 -3 -293 -2 0 550 0 550 440 0 440 0 0 -399z m-40
            -484 c0 -1 -40 -43 -90 -92 l-90 -90 0 93 0 92 90 0 c50 0 90 -1 90 -3z"/>
            <path d="M354 1026 c-7 -19 -90 -46 -133 -43 -40 2 -63 -22 -45 -50 16 -25 57
            -23 68 3 6 13 28 27 57 36 42 14 49 14 63 0 13 -13 19 -14 40 -3 21 12 31 9
            90 -24 36 -20 66 -43 66 -50 0 -15 27 -45 41 -45 5 0 19 10 31 23 12 12 54 41
            92 63 57 34 74 39 88 30 14 -8 22 -6 39 10 17 18 19 25 10 43 -16 28 -61 29
            -68 1 -7 -26 -154 -113 -167 -100 -6 6 -23 10 -38 10 -29 0 -157 72 -171 96
            -11 18 -56 18 -63 0z m46 -21 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7
            15 15 15 8 0 15 -7 15 -15z m440 0 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0
            8 7 15 15 15 8 0 15 -7 15 -15z m-614 -46 c10 -17 -13 -36 -27 -22 -12 12 -4
            33 11 33 5 0 12 -5 16 -11z m392 -67 c2 -7 -6 -12 -17 -12 -21 0 -27 11 -14
            24 9 9 26 2 31 -12z"/>
            <path d="M258 913 l-58 -26 0 -173 0 -174 80 0 80 0 0 200 0 200 -22 0 c-13 0
            -49 -12 -80 -27z"/>
            <path d="M420 736 l0 -196 85 0 85 0 0 133 0 132 -75 60 c-41 33 -79 61 -85
            63 -7 3 -10 -61 -10 -192z"/>
            <path d="M720 880 c-34 -27 -66 -50 -71 -50 -5 0 -9 -65 -9 -145 l0 -145 85 0
            85 0 0 195 c0 159 -3 195 -14 195 -7 0 -42 -22 -76 -50z"/>
            <path d="M173 374 c-3 -9 -2 -24 4 -33 9 -14 38 -16 197 -19 l186 -2 0 35 0
            35 -190 0 c-167 0 -191 -2 -197 -16z"/>
            <path d="M174 246 c-3 -8 -4 -23 -2 -33 3 -16 19 -18 196 -21 l192 -2 0 35 0
            35 -190 0 c-157 0 -192 -3 -196 -14z"/>
            </g>
          </svg>

        </button>
        <DevextremeToolTip
          target="#generatePdfButton"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          position="bottom"
          // visible={true}
        >
          <div className="custom-tooltip">Download Report</div>
        </DevextremeToolTip>
      </div>
      </section>
        <div className='btnDateContainerEvents'>
        <SelectBox
              style={{ marginRight: '10px', width: '20%' }}
              dataSource={['Today', 'Last 5 min', 'Last 20 min', 'Last 1 hour', 'Last 4 hours', 'Last 12 hours', 'Last 24 hours', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Last Month', 'Last 7 days', 'Custom']}
              value={selectedValue}
              // onValueChanged={handleValueChange}
              onValueChanged={(e) => handleValueChange(e.value)}
              labelMode="static"
              label="Period"
              stylingMode="outlined"
            />
            <div onClick={() => handleStartDate()}>
              <DateBox
                ref={dateBoxRefStartEvent}
                style={{ marginRight: '10px'}}
                type="datetime"
                value={startDate}
                onValueChanged={async (e) => await handleStartDateChange(e.value)}
                placeholder="Start Date"
                labelMode="static"
                label="Start Date"
                stylingMode="outlined"
                displayFormat="yyyy-MM-dd HH:mm"
                valueFormat="yyyy-MM-dd HH:mm"
              />
            </div>
            <div onClick={() => handleEndDate()}>
              <DateBox
                ref={dateBoxRefEndEvent}
                style={{ marginRight: '10px'}}
                type="datetime"
                value={endDate}
                onValueChanged={async (e) => await handleEndDateChange(e.value)}
                placeholder="End Date"
                labelMode="static"
                label="End Date"
                stylingMode="outlined"
                displayFormat="yyyy-MM-dd HH:mm"
                valueFormat="yyyy-MM-dd HH:mm"
              />
            </div>

        </div>
      {/* </Popup> */}
					<div className='analyticsContainerEvents'>
						<div className='eventAnalyticsPage'>
							<Chart
                id="eventChart"
                animation={{"enabled":false}}
                dataSource={events}
                onLegendClick={onLegendClick}
                margin={{ left: 20, bottom: 50, right: 50}} 
                > 
                  <Size
                    width={'80%'}
                    height={200}
                  />
                  <ArgumentAxis>
                    <Label wordWrap="normal">
                      <Font color="var(--app-text)" />
                    </Label>
                  </ArgumentAxis>
                  <ValueAxis>
                    <Label>
                      <Font color="var(--app-text)" />
                    </Label>
                    <Tick color="var(--app-text)" />
                  </ValueAxis>
                  <CommonSeriesSettings
                    argumentField="time"
                    type="stackedBar"
                  />
                  <CommonSeriesSettings
                    argumentField="time"
                    type="stackedBar"
                  />

                  <ChartSeries
                    valueField="critical"
                    name="Critical"
                    color="#D71109"
                  />
                  <ChartSeries
                    valueField="alarm"
                    name="Alarm"
                    color="#FFC001"
                  />
                  <ChartSeries
                    valueField="warning"
                    name="Warning"
                    color="#6D6D6D"
                  />
                  <ChartSeries
                    valueField="information"
                    name="Information"
                    color="#CCCCCC"
                  />
                  <ChartLegend
                    // customizeItems={sortLegendItems}
                    style={{cursor:"pointer"}}
                    verticalAlignment="left"
                    horizontalAlignment="left"
                    itemTextPosition="left"
                  >
                    <Font color="var(--app-text)" />
                  </ChartLegend>
                  <Export enabled={false} />
                  <Tooltip
                    enabled={true}
                    horizontalAlignment="left"
                    customizeTooltip={customizeEventsLabel}
                  />
                </Chart>
						</div>
					</div>
				</div>
      </div>
      <DataGrid
        id="events"
        loadPanel={false}
        noDataText={loadingText}
        keyExpr="id"
        showColumnLines={true}
        showRowLines={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnMinWidth={20}
        columnAutoWidth={true}
        showBorders={true}
        ref={dropDataGridRef}
        // onRowInserting={onRowInserting}
        // onRowUpdating={onRowUpdating}
        onColumnsChanging={function (e) { if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
          setLoadingText('No Data'); }
        }}
        dataSource={eventFilters.length>0 ? filterData : data}>
        <Paging enabled={false} key={'paging'}/>
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('time')}
          caption={"Date"}
          minWidth={100}
          width={220}
          dataType="datetime"
          format="yyyy-MM-dd HH:mm"
          key={'time'}
          fixed={true}
          defaultSortOrder="desc"
        >
        </Column>
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('name')}
          caption={'Entity'}
          visible={true}
          dataType='string'
          key={'name'}
          fixed={true}
          minWidth={50}
          width={120}
          calculateDisplayValue={handleEntityName}
        >
        </Column>
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('type')}
          caption={'Type'}
          dataType='string'
          visible={true}
          key={'type'}
          fixed={true}
          minWidth={30}
          width={200}
          calculateDisplayValue={computeValType}
        ></Column>
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('severity')}
          showInColumnChooser={false}
          caption={'Severity'}
          dataType="string"
          visible={true}
          minWidth={10}
          width={120}
          key={'severity'}
          fixed={true}
        ></Column>
        <Column
          allowSorting={true}
          dataField={DOMPurify.sanitize('description')}
          caption={'Description'}
          key={'description'}
          fixed={true}
          minWidth={50}
          visible={true}
        >
        </Column>
      </DataGrid>
      <LoadingPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        hideOnOutsideClick={false}
      />
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
      </div>
    </>
  );
}